import React from 'react';
import Row from 'react-bootstrap/Row';
import { Spacing } from '_styles';

const CustomDivider = (props) => {

    return (
        <div style={{ opacity: 0.4, marginLeft: props?.noMargin ? 0 : Spacing.SCALE_22, marginRight: props?.noMargin ? 0 : Spacing.SCALE_22 }}>
            <hr />
        </div>
    );
};

export default CustomDivider;
